/* FP HOME V4 30/09/2026 : apparitions douces au defilement ([data-rv]). */
(function () {
  if (!('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  var els = document.querySelectorAll('[data-rv]');
  if (!els.length) return;
  document.documentElement.classList.add('fp3-rv-on');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -10% 0px' });
  Array.prototype.forEach.call(els, function (el) {
    if (el.getBoundingClientRect().top < window.innerHeight * 0.9) { el.classList.add('is-in'); }
    io.observe(el);
  });
})();
